import script from "./AdRuleView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdRuleView.vue?vue&type=script&setup=true&lang=js"

import "./AdRuleView.vue?vue&type=style&index=0&id=bbadd49c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbadd49c"]])

export default __exports__